module.exports = __webpack_public_path__ + "static/media/icons-alt.d2840fa7.svg";